import { SectionHeader, SelectableCard, Text } from "@/components/ui"
import { ReactNode } from "react"

type SlotPickerSectionProps = {
  subtitle?: ReactNode
  children?: ReactNode
}

/**
 * Shell of the choose-a-time group. Same heading, spacing and nesting as the
 * pickup/delivery groups beside it so the picker reads as one more step group.
 */
export function SlotPickerSection({ subtitle, children }: SlotPickerSectionProps) {
  return (
    <div>
      <SectionHeader title="Escolha o horário" />
      {subtitle ? (
        <Text size="base" tone="muted" className="mb-3">
          {subtitle}
        </Text>
      ) : null}
      {children}
    </div>
  )
}

type SlotOptionProps = {
  value: string
  children: ReactNode
  /** Second line under the slot, e.g. the arrival estimate under the departure time. */
  subtitle?: ReactNode
}

/**
 * One entry of a slot grid: a `SelectableCard` radio of the enclosing `SelectableCardGroup`, with the
 * same treatment as the channel cards above it so the hour a customer picks looks chosen the same way.
 */
export function SlotOption({ value, children, subtitle }: SlotOptionProps) {
  return (
    <SelectableCard
      value={value}
      tone="secondary"
      density="sm"
      titleWeight="selection"
      wrapTitle
      title={children}
      subtitle={subtitle}
    />
  )
}
